import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyAVXtyXXUIuxZciTQDEa2kx4hRbKV7TJ4o",
  authDomain: "finans-utbildarna.firebaseapp.com",
  projectId: "finans-utbildarna",
  storageBucket: "finans-utbildarna.appspot.com",
  messagingSenderId: "881447579380",
  appId: "1:881447579380:web:a8ed64f7e40d08d970f8a1",
  measurementId: "G-LYZ3H98QH4",
};

// Dev
// const firebaseConfig = {
//   apiKey: "AIzaSyAVXtyXXUIuxZciTQDEa2kx4hRbKV7TJ4o",
//   authDomain: "finans-utbildarna.firebaseapp.com",
//   projectId: "finans-utbildarna",
//   storageBucket: "finans-utbildarna.appspot.com",
//   messagingSenderId: "881447579380",
//   appId: "1:881447579380:web:a8ed64f7e40d08d970f8a1",
//   measurementId: "G-LYZ3H98QH4",
// };

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app, "europe-west1");
export const storage = getStorage(app);
